import { Howl, Howler } from 'howler';

// Set default volume for all sounds
Howler.volume(0.7);

// Create the sound instances
const sounds = {
  // Notification sounds
  notification: new Howl({
    src: ['/sounds/notification.mp3'],
    volume: 0.5
  }),
  
  // UI interactions
  buttonClick: new Howl({
    src: ['/sounds/button-click.mp3'],
    volume: 0.3
  }),
  
  // Glitch/digital effects
  minorGlitch: new Howl({
    src: ['/sounds/minor-glitch.mp3'],
    volume: 0.09  // Reduced by 50% from 0.18
  }),
  
  mediumGlitch: new Howl({
    src: ['/sounds/medium-glitch.mp3'],
    volume: 0.1125  // Reduced by 50% from 0.225
  }),
  
  majorGlitch: new Howl({
    src: ['/sounds/major-glitch.mp3'],
    volume: 0.1575  // Reduced by 50% from 0.315
  }),
  
  // Message sounds
  messageSent: new Howl({
    src: ['/sounds/message-sent.mp3'],
    volume: 0.3
  }),
  
  messageReceived: new Howl({
    src: ['/sounds/message-received.mp3'],
    volume: 0.3
  }),
  
  // Special events
  questionUnlocked: new Howl({
    src: ['/sounds/question-unlocked.mp3'],
    volume: 0.6
  }),
  
  allQuestionsCompleted: new Howl({
    src: ['/sounds/all-questions-completed.mp3'],
    volume: 0.7
  }),
  
  aiDisconnected: new Howl({
    src: ['/sounds/ai-disconnected.mp3'],
    volume: 0.4  // Reduced by 50% from 0.8
  }),
  
  documentAttached: new Howl({
    src: ['/sounds/document-attached.mp3'],
    volume: 0.4
  }),
  
  // Background ambient sound for Rebel.AI conversation
  aiAmbient: new Howl({
    src: ['/sounds/ai-ambient.mp3'],
    volume: 0.15,
    loop: true,
    autoplay: false
  })
};

// Utility functions for playing sounds
const SoundEffects = {
  // Play a sound by name
  play: (soundName) => {
    if (sounds[soundName]) {
      sounds[soundName].play();
    } else {
      console.warn(`Sound "${soundName}" not found`);
    }
  },
  
  // Special function to start/stop the ambient sound
  startAmbient: () => {
    sounds.aiAmbient.play();
  },
  
  stopAmbient: () => {
    sounds.aiAmbient.fade(sounds.aiAmbient.volume(), 0, 1000);
    setTimeout(() => {
      sounds.aiAmbient.stop();
    }, 1000);
  },
  
  // Check if all sounds are loaded
  areLoaded: () => {
    return Object.values(sounds).every(sound => sound._loaded);
  },
  
  // Set master volume for all sounds
  setMasterVolume: (volume) => {
    Howler.volume(volume);
  },
  
  // Mute/unmute all sounds
  mute: () => {
    Howler.mute(true);
  },
  
  unmute: () => {
    Howler.mute(false);
  }
};

export default SoundEffects;